import { Component } from '@angular/core';

@Component({
  selector: 'app-offer-dialog',
  standalone: true,
  imports: [],
  templateUrl: './offer-dialog.component.html',
  styleUrl: './offer-dialog.component.css'
})
export class OfferDialogComponent {

}
